import React, { useState, useReducer, useMemo } from 'react';
import { StyleSheet, View, SectionList, TextInput } from 'react-native';

import WrapBottomColor from '../../containers/WrapBottomColor';
import BottomButton from '../../BottomButton';
import SwitchWithLabel from '../../SwitchWithLabel';
import { CommonProperties, CommonStyles } from '../../../styles';
import TitleSummaryList from '../../tripSummary/TitleSummary';
import BaseText from '../../BaseText';
import { AvatarActionTypes } from '../../TripHub/Traveler/AvatarTraveler';
import TravelerList from '../../TripHub/Traveler/TravelerList';
import produce from 'immer';
import InputAnimated from '../../InputAnimated';
import TravelerItem from '../../TripHub/Social/TravelerItem';

const initialState = {
  searchText: '',
  users: [],
  data: [
    {
      title: 'A',
      data: [
        { name: 'April A.', desc: 'Connection', checked: false },
        { name: 'April B.', desc: 'Connection', checked: false },
      ],
    },
    {
      title: 'B',
      data: [
        { name: 'April C.', desc: 'Connection', checked: false },
        { name: 'April D.', desc: 'Connection', checked: false },
      ],
    },
    {
      title: 'C',
      data: [
        { name: 'April E.', desc: 'Connection', checked: false },
        { name: 'April F.', desc: 'Connection', checked: false },
      ],
    },
    {
      title: 'D',
      data: [
        { name: 'April G.', desc: 'Connection', checked: false },
        { name: 'April I.', desc: 'Connection', checked: false },
      ],
    },
  ],
};

const TOGGLE_USER = 'TOGGLE_USER';

const reducer = (state, action) => {
  switch (action.type) {
    case TOGGLE_USER:
      return produce(state, (draft) => {
        const { title, index, value } = action?.payload;
        let parent = title;

        if (isNaN(title)) {
          parent = state.data.findIndex((item) => item.title === title);
        }

        const indexUser = state.users.findIndex((i) => parent === i.parent && index === i.index);
        if (indexUser === -1) {
          draft.users.push({ ...state.data[parent].data[index], checked: value, parent, index });
        } else {
          draft.users.splice(indexUser, 1);
        }
        draft.data[parent].data[index].checked = value;
      });
    default:
      return state;
  }
};

const InviteTravelerModal = () => {
  const [{ users, data }, dispatch] = useReducer(reducer, initialState);
  const [mayInvite, setMayInvite] = useState(false);
  const [maySchedule, setMaySchedule] = useState(false);
  const [desc, setDesc] = useState('');
  const [searchText, setSearchText] = useState('');
  const filteredData = useMemo(
    () =>
      data
        .map((traveler) => {
          return {
            ...traveler,
            data: traveler.data.filter((traveler) =>
              traveler.name.toLowerCase().includes(searchText.toLowerCase())
            ),
          };
        })
        .filter((section) => section.data.length > 0),
    [data, searchText]
  );

  return (
    <WrapBottomColor>
      <View style={styles.container}>
        <View style={CommonStyles.p3}>
          <InputAnimated
            label="Description"
            value={desc}
            onChangeText={setDesc}
            multiline
            numberOfLines={4}
          />
          <SwitchWithLabel
            left
            label="Invited may invite others"
            value={mayInvite}
            onPress={() => setMayInvite(!mayInvite)}
          />
          <SwitchWithLabel
            left
            label="Invited may add to schedule"
            value={maySchedule}
            onPress={() => setMaySchedule(!maySchedule)}
          />
          <TitleSummaryList style={CommonStyles.mt3} iconName="person" desc="Add Members" />
          <TextInput
            style={styles.searchInput}
            value={searchText}
            onChangeText={(text) => {
              setSearchText(text);
            }}
            placeholder="Search by Name or Invite Via Email"
          />
        </View>
        {users.length > 0 ? (
          <View>
            <BaseText
              style={{ ...CommonProperties.px3, ...CommonProperties.py1, ...CommonProperties.h3 }}
            >
              Invited
            </BaseText>
            <TravelerList
              list={users}
              avatarActionType={AvatarActionTypes.CANCEL}
              onPress={(item) => {
                dispatch({
                  type: TOGGLE_USER,
                  payload: { title: item.parent, index: item.index, value: !item.checked },
                });
              }}
            />
          </View>
        ) : null}
        <SectionList
          sections={filteredData}
          keyExtractor={(item, index) => item.name + index}
          renderItem={({ item, index, section }) => (
            <TravelerItem
              item={item}
              index={index}
              section={section}
              onPress={() =>
                dispatch({
                  type: TOGGLE_USER,
                  payload: { title: section.title, index, value: !item.checked },
                })
              }
            />
          )}
          renderSectionHeader={({ section: { title } }) => (
            <BaseText style={styles.section}>{title}</BaseText>
          )}
        />
      </View>
      <BottomButton label="Invite" disabled={users.length === 0} full onPress={() => {}} />
    </WrapBottomColor>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'white',
  },
  section: {
    ...CommonProperties.px3,
    ...CommonProperties.h3,
  },
  searchInput: {
    borderColor: '#808080',
    borderWidth: 1,
    ...CommonProperties.borderRadius1,
    ...CommonProperties.body,
    ...CommonProperties.mt4,
    ...CommonProperties.p3,
  },
});

export default InviteTravelerModal;
